/**
 * カスタムベクター（Phase 30）
 *
 * - 管理画面で .svg をアップロード
 * - Storage パス: marketing/vector-svgs/{filename}
 * - Firestore: customVectors/{id}
 * - 広告画像エディタの「カスタム SVG」セクションに表示
 * - 配置時は AdVectorElement.customSvgUrl にこの URL をコピー
 */
import type { IsoOrTimestamp } from './common';

export type CustomVectorCategory = 'frame' | 'stamp' | 'decoration' | 'other';

export interface CustomVector {
  id: string;
  /** UI 表示用ラベル */
  name: string;
  /** Storage の公開 URL */
  url: string;
  /** Storage パス（削除用） */
  storagePath: string;
  /** 分類 */
  category: CustomVectorCategory;
  /** バイトサイズ */
  size: number;
  createdAt: IsoOrTimestamp;
  createdBy?: string;
}

export const CUSTOM_VECTOR_STORAGE_PATH = 'marketing/vector-svgs';
export const CUSTOM_VECTOR_MAX_BYTES = 1 * 1024 * 1024; // 1 MB（SVG は通常数十KB）

export const CUSTOM_VECTOR_CATEGORY_LABELS: Record<CustomVectorCategory, string> = {
  frame: 'フレーム',
  stamp: 'スタンプ装飾',
  decoration: '装飾',
  other: 'その他',
};
